import { Component, Injectable, Input ,ViewChild,inject , signal, SimpleChanges, OnChanges, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Form } from '../../form/form.component';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { Divider } from '../../divider/divider.component';
import { Titledescription } from '../../titledescription/titledescription.component';
import { Button } from '../../button/button.component';
import { FormField } from '../../../../constants/form.constants';
import { CardComponent } from '../../card/card.component';
import { MatDividerModule } from '@angular/material/divider';
import { ApiService } from '../../../../core/api.service';
import { AlertComponent } from '../../alert/alert.component';
import { Location } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-crud-edit',
  imports: [CommonModule, Button, Titledescription, Form, MatDividerModule, CardComponent, MatProgressSpinnerModule],
  templateUrl: './edit.html',
  styleUrl: './edit.scss'
})
export class CrudEditComponent<T> implements OnChanges {
  @Input() apiService!: ApiService<T>;
  backUrl = signal('');
  model!: any;
  @Input() fields: { [name: string]: FormField } = {};
  @Input() title: string = '';
  @Input() description: string = '';
  @Input() id?: number;
  @Input() backButton: boolean = true;
  @Input() actionButtons: boolean = true;
  @Input() isLoading: boolean = false;
  @Input() goBackInModal: boolean = true;
  @Input() templateHeaderDescription !: any;
  @Output() dataForm = new EventEmitter<any>();
  @Output() formSubmitEvent = new EventEmitter<any>();
  @Output() selectFieldValueEmit = new EventEmitter<any>();

  idFromUrl = signal('');
  @ViewChild('formGeneral', { static: false }) form!: Form ;
  private alert = inject(AlertComponent);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);
  private subscriptions: Subscription[] = [];

  get idFinal(): number | undefined {
    return this.id !== undefined ? this.id : Number(this.idFromUrl());
  }

  constructor() {
    const urlSub = this.activatedRoute.url.subscribe((UrlSegment: UrlSegment[]) => {
      this.backUrl.set(UrlSegment[0].path);
      const paramsSub = this.activatedRoute.params.subscribe((params) => {
        if (this.id === undefined) {
          this.idFromUrl.set(params['id']);
        }
      });
      this.subscriptions.push(paramsSub);
    });
    this.subscriptions.push(urlSub);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  ngOnInit() {
    this.loadModel();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['id'] && !changes['id'].firstChange) {
      this.loadModel();
    }
  }

  loadModel() {
    const idValue = this.idFinal;
    if (idValue) {
      this.isLoading = true;
      this.apiService.getById(Number(idValue)).subscribe((data) => {
        this.dataForm.emit(data);
        this.model = data;
        // Esperar al siguiente ciclo para asegurar que el formulario esté renderizado
          if (this.form && this.form.form) {
            this.form.patchFormValues(this.model);
          }
      });
    }
  }

  submit() {
    const submitForm = this.form.onSubmit();
    if (submitForm) {
      console.log("this.goBackInModal",this.goBackInModal)
      this.alert.goBack = this.goBackInModal ?? true;
      this.apiService.update(submitForm, Number(this.idFinal)).subscribe({
        next: data => {
          this.alert.openAlert("success", "Guardado!");
          this.apiService.clearCache();
          this.formSubmitEvent.emit(data);
        },
        error: err => {
          this.alert.openAlert("error", "Algo ocurrió");
        }
      });
    }
  }
  clearField(fieldName: string) {
    if (this.form && this.form.form) {
      this.form.form.get(fieldName)?.setValue('');
    }
  }
  setFieldOptions(fieldName: string, options: any[]) {
    if (this.fields[fieldName]) {
      this.fields[fieldName].options = [...options];
      this.form.originalOptionsMap[fieldName] = [...options]; // Actualiza el mapa de opciones originales
      this.form.selectOptionsFiltered[fieldName] = [...options]; // Actualiza las opciones filtradas para que reflejen el cambio
    }
  }
  navigateToBack() {
    this.location.back();
  }
}

